import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { slideInLeft } from "./animationVariants";

export default function AgentSidebar({ agent, otherAgents }) {
  return (
    <motion.div
      {...slideInLeft}
      className="lg:col-span-4 flex flex-col"
    >
      <div className="h-full p-7 md:p-8 bg-card border border-border rounded-2xl flex flex-col">
        <div className="flex items-center gap-4 mb-5">
          {agent.avatar ? (
            <img
              src={agent.avatar}
              alt={`${agent.name} — ${agent.role}`}
              className="h-14 w-14 rounded-2xl object-cover bg-primary/10"
            />
          ) : (
            <div className="h-14 w-14 rounded-2xl bg-primary/10 grid place-items-center font-display text-primary text-2xl font-bold">
              ✓
            </div>
          )}
          <div>
            <div className="eyebrow text-[0.6rem] mb-0.5">{agent.role}</div>
            <h1 className="font-display text-3xl font-semibold leading-tight m-0">
              {agent.name}
            </h1>
          </div>
        </div>
        <p className="text-lg md:text-xl text-foreground/80 leading-relaxed flex-1">
          {agent.blurb}
        </p>
        <div className="mt-7 inline-flex items-center gap-2 text-sm font-medium text-primary">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-accent opacity-75 animate-ping" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-accent" />
          </span>
          Live · responses processed by Integrated Clinical Intelligence
        </div>

        <div className="mt-7 grid grid-cols-1 gap-2">
          {otherAgents.map((a) => (
            <Link
              key={a.id}
              to={`/agents/${a.id}`}
              data-testid={`agent-switch-${a.id}`}
              className="group flex items-center gap-3 px-3 py-2 rounded-xl border border-border bg-background/60 hover:border-primary/55 transition-colors"
            >
              {a.avatar ? (
                <img
                  src={a.avatar}
                  alt=""
                  className="h-8 w-8 rounded-lg object-cover bg-primary/10"
                />
              ) : (
                <div className="h-8 w-8 rounded-lg bg-primary/10 grid place-items-center font-display text-primary text-sm font-bold">
                  ✓
                </div>
              )}
              <div className="min-w-0 flex-1">
                <div className="font-display text-sm font-semibold leading-tight">
                  {a.name}
                </div>
                <div className="text-[0.65rem] uppercase tracking-wider text-muted-foreground truncate">
                  {a.role}
                </div>
              </div>
              <span aria-hidden className="text-primary group-hover:translate-x-0.5 transition-transform">
                →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
